export class InvalidAccessTokenError extends Error {
  constructor() {
    super();
    this.name = 'InvalidAccessTokenError';
    Object.setPrototypeOf(this, InvalidAccessTokenError.prototype);
  }
}
